// extracted by mini-css-extract-plugin
export var button = "_k0-2";
export var card = "_k0-0";
export var closeButtonContainer = "_k0-3";
export var iconContainer = "_k0-1";